import gql from 'graphql-tag'
export const GET_SEEKER_NEW = gql`
query (
  $_id: ID!
) {
edit_Seeker(_id: $_id) {
      seeker{
      _id
      fullName
      status
      showStatus
      mobile
      reason
      CVStatus
      authId{
          email
          mobile
      }
      registerSeeker{
          _id
          drivingLicenses
              districtId{
              _id
              name
              provinceId{
                  _id
                  name
              }
          }
          dateOfBirth
          professionalSummary
          fileId{
              _id
              link
              src
              type
              mimeType
          }
          firstName
          lastName
          maritalStatusId{
              _id
              name
          }
          genderId{
              _id
              name
          }
      }
      resume{
          _id
          point
          fileId{
              _id
              link
              src
          }
          education{
              _id
              department
          degreeId{
              _id
              name
          }
          }
          languageSkill{
              _id
              LanguageId{ 
                  _id
                  name}
              LanguageLevelId{
                  _id 
                  name
              }
          }
          keySkillIds{
              _id
              name
          }
          jobLevelId{
            _id
            name
          }
          jobFunctionId{
            _id 
            name
          }
          jobTagId {
            _id
              name
          }
        skillTagId  {
            _id
              name
          }
        additionalTagId {
            _id
              name
          }
          workingExperience{
              _id
            LatestJobTitle
              previousJobTitlesId{
                  _id
                  name
              }
              previousEmployersId{
                  _id
                  name
              }
              previousEmployerIndustryId{
                  _id
              name
              }
              SalayRangeId{
                  _id
                  name
              }
              totalWorkingExperience 
          }
  }
      }
      appliedJob
  saveJob
}
}
`

export const GET_SEEKER = gql`
query(
  $type:String
  $search:String
  $CVStatus:Boolean
  $page: Int
  $perPage:Int
  $skillTagId:[ID]
  $jobFunctionId:[ID]
  $jobLevelId:[ID]
)
{
  getRegisterseeker (type:$type search:$search CVStatus:$CVStatus 
  page: $page perPage:$perPage jobFunctionId:$jobFunctionId jobLevelId:$jobLevelId skillTagId:$skillTagId){
      getSeeker{
          _id
  profile
  fullName
  firstName
  lastName
  email
  mobile
  updatedAt
  point
  jobLevels
  status
  showStatus
  isSearchable
  CVStatus
  }
      totals
}
}
`
export const SEEKER_DETAIL = gql`
query (
  $id: ID!
) {
  getSeekerX (
    id: $id
  ) {
    auth {
      email
      mobile
    }
    seeker {
      seekerId
        professionalSummary
        fullName
        gender
        maritalStatus
        image
        dateOfBirth
        status
        showStatus
    }
    resume {
        _id
        CVStatus
        resume
        keySkills
        educations
        languageSkills
        latestJobTitle
        previousJobTitles
        previousEmployers
        previousEmployerIndustry
        totalWorkingExperience
        salaryRange
        point
    }
    appliedJob
    saveJob
  }
}
`

export const CHANGE_SEEKER_STATUS = gql`
mutation(
  $seekerId:ID!
  $status:String!
  $reason:String
){
  isApprovedSeeker(
    seekerId:$seekerId
    status:$status
    reason:$reason
  ){
    _id
     status
    isVerified
  }  
}
`
export const ADD_POINT_NEW = gql`
mutation(
  $point:Int
  $employerId:ID
){
      addCVPoint(info:{
          point:$point
          employerId:$employerId})
  }
`
export const ADD_POINT = gql`
mutation(
  $resumeId: ID!,
  $point: Int!
){
  addResumePoint(resumeId:$resumeId point:$point){
    _id
    point
    view
    viewDaily
    viewMonthly
  }
}
`

export const SEEKER_UNFINISH = gql`
mutation(
  $seekerId:ID!
){
  unfinishSeeker(
    seekerId:$seekerId
  ){
      _id
      isVerified
    
    }
}
`
export const CHECK = gql`
mutation(
  $seekerId:ID!
){
  markRead(seekerId:$seekerId){
      _id
      CVStatus
  }
}
`
export const DELETE = gql`
mutation(
  $seekerId:ID!
){
  deleteSeeker(seekerId:$seekerId)
}
`

export const CHECK_EX = gql`
mutation(
  $seekerId:ID!
){
  checkSeeker(seekerId:$seekerId)
  {
  _id
		fullName
		showStatus
  }
}

`

export const UPDATE_SEEKER = gql`
mutation (
  $registerSeekerId: ID!
  $seekerId: ID!
  $professionalSummary: String!
  $districtId: ID!
  $dateOfBirth: Date!
  $firstName: String!
  $lastName: String!
  $genderId: ID!
  $maritalStatusId: ID!
  $drivingLicenses: [String]!
  $logo: logoupdate
  $educatU: [EducationUpdate]!
  $lanU: [updateLanguageSkill]!
  $workingU: InputupdateWorkingExperience
  $resumesU: updateResume!
) {
  updateRegisterSeeker(info: {
          registerSeekerId: $registerSeekerId
          seekerId: $seekerId
          professionalSummary: $professionalSummary
          districtId: $districtId
          dateOfBirth: $dateOfBirth
          firstName: $firstName
          lastName: $lastName
          genderId: $genderId
          maritalStatusId: $maritalStatusId
          drivingLicenses: $drivingLicenses
          logo: $logo
          educatU: $educatU
          LanU: $lanU
          workingU: $workingU
          resumeU: $resumesU
      }
  ){
      _id
       fullName
      mobile
      status
      showStatus
      authId{
          email
          mobile
      }
      registerSeeker{
          _id
          fileId{
              _id
              link
              src
              type
              mimeType
          }
          firstName
          lastName
          maritalStatusId{
              _id
              name
          }
          genderId{
              _id
              name
          }
      }
      resume{
          _id
          point
          fileId{
              _id
              link
              src
          }
          education{
              _id
              department
          degreeId{
              _id
              name
          }
          }
          languageSkill{
              _id
              LanguageId{ _id name}
              LanguageLevelId{_id name}
          }
          keySkillIds{
              _id
              name
          }
          jobFunctionId{
            _id 
            name
          }
          jobLevelId{
            _id
            name
          }
          jobTagId {
            _id
              name
          }
        skillTagId  {
            _id
              name
          }
        additionalTagId {
            _id
              name
          }
          workingExperience{
              _id
            LatestJobTitle
              previousJobTitlesId{
                  _id
                  name
              }
              previousEmployersId{
                  _id
                  name
              }
              previousEmployerIndustryId{_id
              name}
              SalayRangeId{
                  _id
                  name
              }
              totalWorkingExperience 
          }
      }
  }
}
`

export const CHANGE_MOBILE = gql`
mutation (
  $seekerId: ID,
 $mobile: String
 ) {	ChangeMobile(info: {
     seekerId: $seekerId,
      mobile: $mobile 
      })
}

`

export const UPDATE_ISSEARCHABLE = gql`
mutation (
  $_id: ID,
  $isSearchable:Boolean
 ) {	updateisSearchableCV(info: {
     _id: $_id,
      isSearchable: $isSearchable 
      })
}
`